export const formatNumber = (number) => {
    return number.toLocaleString("en-US", { maximumFractionDigits: 2 });
}

function Unidades(num){

    switch(num)
    {
        case 1: return "UN";
        case 2: return "DOS";
        case 3: return "TRES";
        case 4: return "CUATRO";
        case 5: return "CINCO";
        case 6: return "SEIS";
        case 7: return "SIETE";
        case 8: return "OCHO";
        case 9: return "NUEVE";
    }

    return "";
}//Unidades()

function Decenas(num){

    let decena = Math.floor(num/10);
    let unidad = num - (decena * 10);

    switch(decena)
    {
        case 1:
            switch(unidad)
            {
                case 0: return "DIEZ";
                case 1: return "ONCE";
                case 2: return "DOCE";
                case 3: return "TRECE";
                case 4: return "CATORCE";
                case 5: return "QUINCE";
                default: return "DIECI" + Unidades(unidad);
            }
        case 2:
            switch(unidad)
            {
                case 0: return "VEINTE";
                default: return "VEINTI" + Unidades(unidad);
            }
        case 3: return DecenasY("TREINTA", unidad);
        case 4: return DecenasY("CUARENTA", unidad);
        case 5: return DecenasY("CINCUENTA", unidad);
        case 6: return DecenasY("SESENTA", unidad);
        case 7: return DecenasY("SETENTA", unidad);
        case 8: return DecenasY("OCHENTA", unidad);
        case 9: return DecenasY("NOVENTA", unidad);
        case 0: return Unidades(unidad);
    }
}//Unidades()

function DecenasY(strSin, numUnidades) {
    if (numUnidades > 0)
    return strSin + " Y " + Unidades(numUnidades)

    return strSin;
}//DecenasY()

function Centenas(num) {
    let centenas = Math.floor(num / 100);
    let decenas = num - (centenas * 100);

    switch(centenas)
    {
        case 1:
            if (decenas > 0)
                return "CIENTO " + Decenas(decenas);
            return "CIEN";
        case 2: return "DOSCIENTOS " + Decenas(decenas);
        case 3: return "TRESCIENTOS " + Decenas(decenas);
        case 4: return "CUATROCIENTOS " + Decenas(decenas);
        case 5: return "QUINIENTOS " + Decenas(decenas);
        case 6: return "SEISCIENTOS " + Decenas(decenas);
        case 7: return "SETECIENTOS " + Decenas(decenas);
        case 8: return "OCHOCIENTOS " + Decenas(decenas);
        case 9: return "NOVECIENTOS " + Decenas(decenas);
    }

    return Decenas(decenas);
}//Centenas()

function Seccion(num, divisor, strSingular, strPlural) {
    let cientos = Math.floor(num / divisor)
    let resto = num - (cientos * divisor)

    let letras = "";

    if (cientos > 0)
        if (cientos > 1)
            letras = Centenas(cientos) + " " + strPlural;
        else
            letras = strSingular;

    if (resto > 0)
        letras += "";

    return letras;
}//Seccion()

function Miles(num) {
    let divisor = 1000;
    let cientos = Math.floor(num / divisor)
    let resto = num - (cientos * divisor)

    let strMiles = Seccion(num, divisor, "UN MIL", "MIL");
    let strCentenas = Centenas(resto);

    if(strMiles == "")
        return strCentenas;

    return strMiles + " " + strCentenas;
}//Miles()

function Millones(num) {
    let divisor = 1000000;
    let cientos = Math.floor(num / divisor)
    let resto = num - (cientos * divisor)

    let strMillones = Seccion(num, divisor, "UN MILLON DE", "MILLONES");
    let strMiles = Miles(resto);

    if(strMillones == "")
        return strMiles;

    return strMillones + " " + strMiles;
}//Millones()

export function numberToLetters(num) {
    var data = {
        numero: num,
        enteros: Math.floor(num),
        centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
        letrasCentavos: "",
        letrasMonedaPlural: '',//"PESOS", 'Dólares', 'Bolívares', 'etcs'
        letrasMonedaSingular: '', //"PESO", 'Dólar', 'Bolivar', 'etc'

        letrasMonedaCentavoPlural: "CENTAVOS",
        letrasMonedaCentavoSingular: "CENTAVO"
    };

    if (data.centavos > 0) {
        data.letrasCentavos = "CON " + (function (){
            if (data.centavos == 1)
                return Millones(data.centavos) + " " + data.letrasMonedaCentavoSingular;
            else
                return Millones(data.centavos) + " " + data.letrasMonedaCentavoPlural;
            })();
    };

    if(data.enteros == 0)
        return "CERO " + data.letrasMonedaPlural + " " + data.letrasCentavos;
    if (data.enteros == 1)
        return Millones(data.enteros) + " " + data.letrasMonedaSingular + " " + data.letrasCentavos;
    else
        return Millones(data.enteros) + " " + data.letrasMonedaPlural + " " + data.letrasCentavos;
}

export const getYear = (num) => {
    let date = new Date();
    let year = date.getFullYear() - num;

    return year;
}

export const getCurrentDate = () => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (day < 10) {
        day = '0' + day;
    }

    if (month < 10) {
        month = '0' + month;
    }

    const newDate = day + '/' + month + '/' + year

    return newDate;
}

export const formatDate = (d) => {
    console.log(d);
    const date = new Date(d.toISOString().slice(0, -1));
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minutes = date.getMinutes();
    let seconds = date.getSeconds();
    let hday = "a.m."

    if(hour > 11){
        hday = "p.m."
    }

    let sDate = year + "-";
    if(month < 10){
        sDate = sDate + "0";
    }
    sDate = sDate + month + "-";
    if(day < 10){
        sDate = sDate + "0";
    }
    sDate = sDate + day + " ";
    
    if(hour > 12){
        if((hour - 12) < 10){
            sDate = sDate + "0";
        }
        sDate = sDate + (hour - 12) + ":";
    } else {
        if((hour) < 10){
            sDate = sDate + "0";
        }
        sDate = sDate + (hour) + ":";
    }

    if(minutes < 10){
        sDate = sDate + "0";
    }
    sDate = sDate + minutes + ":";
    if(seconds < 10){
        sDate = sDate + "0";
    }
    sDate = sDate + seconds + " " + hday;
    

    return sDate;
}

export const formatDateMin = (d) => {
    const date = new Date(d.toISOString().slice(0, -1));
    console.log(date);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    let sDate = year + "/";
    if(month < 10){
        sDate = sDate + "0";
    }
    sDate = sDate + month + "/";
    if(day < 10){
        sDate = sDate + "0";
    }
    sDate = sDate + day + " ";

    return sDate;
}

export const formatDateQuery = (date) => {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    let sDate = year;
    if(month < 10){
        sDate = sDate + "0";
    }
    sDate = sDate + month;
    if(day < 10){
        sDate = sDate + "0";
    }
    sDate = sDate + day;

    return sDate;
}

export const formatDateMin2 = (d) => {
    console.log(d);
    const date = new Date(d.toISOString().slice(0, -1));
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    let sDate = year + "/";
    if(month < 10){
        sDate = sDate + "0";
    }
    sDate = sDate + month + "/";
    if(day < 10){
        sDate = sDate + "0";
    }
    sDate = sDate + day + " ";

    return sDate;
}

export const getDays = (date1, date2) => {
    var difference= Math.abs(date1-date2);
    let days = difference/(1000 * 3600 * 24)

    return days;
}

export const getExpeditionDateByYear = (year) => {
    let intYear= parseInt(year);
    intYear = intYear + 1;
    return '15/01/' + intYear;
}

export const getExpeditionDateByPeriod = (idPeriod) => {
    let intMonth = parseInt(idPeriod.substring(6,8));
    let newYear = '';
    /*if(idPeriod.substring(0,4) === '12') {
        newYear = '01';
    } else {
        newYear = idPeriod.substring(0,4);
    }*/
    if(intMonth === 12) {
        newYear = parseInt(idPeriod.substring(0,4)) + 1;
        intMonth = 0;
    } else {
        newYear = idPeriod.substring(0,4);
    }
    intMonth = intMonth + 1;
    const newMonth = intMonth < 10 ? '0' + intMonth : intMonth;
    return '15/' + newMonth + '/' + newYear;
}

export const JSONToCSVConvertor = (JSONData, ReportTitle, ShowLabel) => {
    //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData =
      typeof JSONData !== "object" ? JSON.parse(JSONData) : JSONData;

    var CSV = "";

    //This condition will generate the Label/Header
    if (ShowLabel) {
      var row = "";

      //This loop will extract the label from 1st index of on array
      for (var index in arrData[0]) {
        //Now convert each value to string and comma-seprated
        if(index !== 'password' ){
            row += index + ",";
        }
      }

      row = row.slice(0, -1);

      //append Label row with line break
      CSV += row + "\r\n";
    }

    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
      var row = "";

      //2nd loop will extract each column and convert it in string comma-seprated
      for (var index in arrData[i]) {
        
        if(index !== 'password' ){
            row += '"' + arrData[i][index] + '",';
        }
      }

      row.slice(0, row.length - 1);

      //add a line break after each row
      CSV += row + "\r\n";
    }

    if (CSV === "") {
      alert("Invalid data");
      return;
    }

    //Generate a file name
    var fileName = "Proveedores_";
    //this will remove the blank-spaces from the title and replace it with an underscore
    fileName += ReportTitle.replace(/ /g, "_");

    //Initialize file format you want csv or xls
    var uri = "data:text/csv;charset=utf-8," + escape(CSV);

    // Now the little tricky part.
    // you can use either>> window.open(uri);
    // but this will not work in some browsers
    // or you will not get the correct file extension

    //this trick will generate a temp <a /> tag
    var link = document.createElement("a");
    link.href = uri;

    //set the visibility hidden so it will not effect on your web-layout
    link.style = "visibility:hidden";
    link.download = fileName + ".csv";

    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };